import { Vue, newVue } from '@/config/vue'
import store from '@/config/vuex'
import { registerStores } from '@/helpers/stores'
import recommendationsStore, { RECOMMENDATION_BLOCK_IDS } from '@/stores/recommendations'

let initiated = {}
const defaultSelector = '.js-vue-product-recommendations'

const init = data => {
  const identifier = data.identifier || 'current-page'
  if (initiated[identifier] && !data.forceInit) return

  const selector = data.el || data.selector || defaultSelector
  registerStores({ recommendations: recommendationsStore })

  if (!data.skus) {
    const container = document.querySelector('.product-recommendations-container')
    const excludeProductId = Number(container?.dataset.excludeProductId)
    store.dispatch('recommendations/fetchProductPageRecommendations', { excludeProductId })
  } else if (On.DynamicYield.arrayOfSkusIsValid(data.skus)) {
    store.dispatch('recommendations/fetchProductPageRecommendations', { skus: data.skus })
  } else if (data.generatedByDynamicYield) {
    On.DynamicYield.trackInvalidRecommendedSkus(data.experimentInfo, data.skus)
  }
  if (data.title) {
    store.commit('recommendations/setHeadline', {
      [RECOMMENDATION_BLOCK_IDS.productPage]: On.helpers.localize(data.title),
    })
  }
  const ProductRecommendations = Vue.component('product-recommendations', () =>
    import(/* webpackChunkName: "product-recommendations" */ '@/components/ProductRecommendations/ProductRecommendations.vue')
  )
  newVue({
    render: h => h(ProductRecommendations),
    mount: selector,
  })
  initiated[identifier] = true
}

const initDelayedCallback = () => {
  On.DynamicYield.delayedCallback(() => init({ selector: defaultSelector }), 'PDP')
}

On.VueInit({
  controller: 'orders',
  action: 'edit',
  init: initDelayedCallback,
})

On.VueInit({
  controller: 'products',
  action: 'show',
  init: initDelayedCallback,
})

window.On.ProductRecommendationsVueInit = init
